export default __webpack_public_path__ + "static/twitterSummaryX-39dad42299649e9c51090c30a651d655.jpg";